/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsactivityhint2Inputs */

const en_statsactivityhint2 = /** @type {(inputs: Statsactivityhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active = sent a message or answered a plan in that window. Percent = share of all accounts.`)
};

const de_statsactivityhint2 = /** @type {(inputs: Statsactivityhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv = hat im Zeitraum eine Nachricht geschrieben oder auf einen Plan geantwortet. Prozent = Anteil aller Konten.`)
};

/**
* | output |
* | --- |
* | "Active = sent a message or answered a plan in that window. Percent = share of all accounts." |
*
* @param {Statsactivityhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsactivityhint2 = /** @type {((inputs?: Statsactivityhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsactivityhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsactivityhint2(inputs)
	return de_statsactivityhint2(inputs)
});
export { statsactivityhint2 as "statsActivityHint" }